import { useModal } from '@/components/modal/useModal';
import SiPlusCircle from '@/icons/SiPlusCircle';
import { FunctionComponent } from 'react';
import { AddPriceAndMarginModal } from '../price/AddPriceAndMarginModal';
import { PriceHistory } from '../price/PriceHistoryModal';

interface CostAndMarginProps {
  productId: string;
}

const CostAndMargin: FunctionComponent<CostAndMarginProps> = ({ productId }) => {
  const addPriceAndMarginModalProps = useModal<{ productId: string }>();

  return (
    <>
      <AddPriceAndMarginModal {...addPriceAndMarginModalProps} />
      <div className="flex flex-col gap-2">
        <label className="text-lg font-medium">Cost & margin</label>
        <button
          className="flex items-center gap-2"
          type="button"
          onClick={() => addPriceAndMarginModalProps.open({ productId })}
        >
          <SiPlusCircle className="text-2xl" />
          <span>Add future change</span>
        </button>
        <PriceHistory productId={productId} />
      </div>
    </>
  );
};

export default CostAndMargin;
